import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RefundModal = ({ isOpen, payment, onClose }) => {
  if (!isOpen || !payment) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden border border-border">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-warning/20">
              <Icon name="RotateCcw" size={24} className="text-warning" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                Process Refund
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                Are you sure you want to refund <span className="font-semibold text-foreground">₹{payment?.amount?.toLocaleString()}</span> to <span className="font-semibold text-foreground">{payment?.clientName}</span>?
              </p>
            </div>
          </div>

          <div className="p-4 bg-warning/10 border border-warning/20 rounded-md mb-6">
            <div className="flex items-start gap-2">
              <Icon name="AlertCircle" size={16} className="text-warning flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-warning font-body">
                  This action cannot be undone
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  The refund will be processed immediately and the client will be notified.
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="warning"
              size="lg"
              onClick={onClose}
              iconName="RotateCcw"
              iconPosition="left"
              fullWidth
            >
              Process Refund
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundModal;